import styled from 'styled-components'

const Heading = styled.h2`
  font-size: ${props => props.theme.font.size['label-2']};
  font-weight: ${props => props.theme.font.weight.bold};
`
const Message = styled.p`
  margin: 24px 0;
  min-height: 100%;
`
const Wrapper = styled.div`
  margin: 50px 0;
`
export { Heading, Message, Wrapper }
